const adsId = process.env.REACT_APP_GOOGLE_ADS_ID;
const conversionLabel = process.env.REACT_APP_GOOGLE_ADS_CONVERSION_LABEL;

function reportConversion() {
  if (!adsId || !conversionLabel || typeof window.gtag !== "function") return;
  window.gtag("event", "conversion", { send_to: `${adsId}/${conversionLabel}` });
}

export function initGoogleAds() {
  document.addEventListener("click", (e) => {
    if (e.target.closest('a[href*="wa.me"]')) reportConversion();
  });

  if (!adsId) return;
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${adsId}`;
  document.head.appendChild(script);
  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };
  window.gtag("js", new Date());
  window.gtag("config", adsId);
}
